import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-kt-drawer-width"]
const _hoisted_2 = { class: "card rounded-0 w-100 bg-light" }
const _hoisted_3 = { class: "card m-5 bg-transparent mb-0" }
const _hoisted_4 = { class: "d-flex align-items-center justify-content-between bg-white px-4 pt-2 me-n2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "las la-expand-arrows-alt fs-3 me-4 text-black-50" })
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<button type=\"button\" class=\"btn btn-sm btn-icon btn-active-color-primary h-40px w-40px me-n2\" id=\"vz__drawer_close\"><span class=\"svg-icon svg-icon-2\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><rect opacity=\"0.5\" x=\"6\" y=\"17.3137\" width=\"16\" height=\"2\" rx=\"1\" transform=\"rotate(-45 6 17.3137)\" fill=\"black\"></rect><rect x=\"7.41422\" y=\"6\" width=\"16\" height=\"2\" rx=\"1\" transform=\"rotate(45 7.41422 6)\" fill=\"black\"></rect></svg></span></button>", 1)
const _hoisted_8 = {
  class: "card-header border-bottom-0 bg-white me-n2",
  id: "vz__drawer_header"
}
const _hoisted_9 = { class: "card-title fw-bolder text-gray-700" }
const _hoisted_10 = { class: "symbol symbol-circle symbol-40px me-4" }
const _hoisted_11 = { class: "symbol-label border border-primary border-dashed" }
const _hoisted_12 = { class: "card-toolbar" }
const _hoisted_13 = {
  class: "card-body mx-5 p-0",
  id: "vz__drawer_body"
}
const _hoisted_14 = {
  id: "kt_explore_scroll",
  class: "scroll-y me-n5 pe-3 mh-md-800px mh-xxl-auto",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#vz__drawer_body",
  "data-kt-scroll-dependencies": "#vz__drawer_header",
  "data-kt-scroll-offset": "5px"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VZTabs = _resolveComponent("VZTabs")!

  return (_openBlock(), _createElementBlock("div", {
    id: "vz__drawer",
    "data-kt-drawer": "true",
    "data-kt-drawer-name": "explore",
    "data-kt-drawer-activate": "true",
    "data-kt-drawer-overlay": "true",
    "data-kt-drawer-width": _ctx.currentWidth,
    "data-kt-drawer-direction": "end",
    "data-kt-drawer-toggle": "#vz__drawer_toggle",
    "data-kt-drawer-close": "#vz__drawer_close"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-icon btn-active-color-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleResize && _ctx.handleResize(...args)))
          }, _hoisted_6),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h3", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("i", {
                  class: _normalizeClass(["fs-3 text-primary", _ctx.icon])
                }, null, 2)
              ])
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_ctx.$slots.actions)
              ? _renderSlot(_ctx.$slots, "actions", { key: 0 })
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_VZTabs, {
            tabs: _ctx.tabs,
            type: _ctx.type,
            direction: _ctx.direction,
            title: _ctx.title,
            icon: _ctx.icon
          }, null, 8, ["tabs", "type", "direction", "title", "icon"])
        ])
      ])
    ])
  ], 8, _hoisted_1))
}